import { render, staticRenderFns } from "./policy-consent-checkbox.vue?vue&type=template&id=426a92fc&scoped=true"
import script from "./policy-consent-checkbox.vue?vue&type=script&lang=js"
export * from "./policy-consent-checkbox.vue?vue&type=script&lang=js"
import style0 from "./policy-consent-checkbox.vue?vue&type=style&index=0&id=426a92fc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426a92fc",
  null
  
)

export default component.exports